import React from 'react';
import { Button, darken, Typography, useTheme } from '@mui/material';
import HelpOutlinedIcon from '@mui/icons-material/HelpOutlined';

const ButtonTienda = ({
  description,
  icon: Icon,
  disabled = false,
  flexDirection = 'column',
  sizeIcon = 35,
  fontSize = 8,
  sx = {},
  active = false,
  onClick,
  onTouchStart,
  dynamicColor, // Nuevo prop para el color dinámico
}) => {
  const theme = useTheme();
  
  // Función para obtener el color a usar
  const getColorToUse = () => {
    return dynamicColor || theme.bandera.colorSecundario;
  };
  
  const btnBistro = {
      borderRadius: '3px',
      width: '100%',
      height: '70px',
      fontWeight: 'bold',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      userSelect: 'none',
      WebkitUserSelect: 'none',
      MozUserSelect: 'none',
      msUserSelect: 'none',
      WebkitTouchCallout: 'none',
      WebkitTapHighlightColor: 'transparent',
      touchAction: 'manipulation',
      cursor: 'pointer',
      '&.MuiButton-contained.MuiButton-root.Mui-disabled': {
        opacity: 0.5,
        backgroundColor: 'rgb(131, 131, 131) !important',
        color: 'black',
      },
      backgroundColor: description==='PROMOCIONES'?theme.bandera.colorPrimario:'#fff',
      color: description==='PROMOCIONES'?'#FFF':'#514641',
      '&:active': {
        backgroundColor: getColorToUse(),
        color: '#fff',
        '& .MuiSvgIcon-root': {
          color: '#fff',
        },
        '& .iconoButton': {
          filter: 'invert(0) !important',
        },
      },
  };
  const renderIcon = () => {
    if (typeof Icon === 'string') {
      // Si el icono es una URL o imagen base64, renderiza una imagen
      return (
        <img
          className='iconoButton'
          src={Icon}
          alt="icon"
          draggable={false}
          style={{
            width: sizeIcon,
            height: sizeIcon,
            objectFit: 'contain',
            filter:  active 
                ? 'invert(0)' 
                : 'invert(0.75) sepia(15%)',
            userSelect: 'none',
            pointerEvents: 'none',
          }}
        />
      );
    }
    if (React.isValidElement(Icon)) {
      // Si es un componente de React (ícono de Material UI), renderízalo
      return React.cloneElement(Icon, {
        // sx: { fontSize: sizeIcon, ...(secondary && { color: '#902421' }) },
      });
    }
    const DisplayIcon = Icon || HelpOutlinedIcon;

    return (
      <DisplayIcon
        sx={{
          fontSize: sizeIcon,
        }}
      />
    );
  };

  return (
    <Button
      fullWidth
      variant="contained"
      disabled={disabled}
      sx={{
        ...btnBistro,
        '&:hover': {
          backgroundColor: `${darken(getColorToUse(), 0.1)} !important`,
        },
        flexDirection,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: flexDirection === 'row' ? 1 : 0,
        padding: 2,
        maxWidth: '100%',
        maxHeight: 100,
        overflow: 'hidden',
        ...sx,
      }}
      onClick={onClick}
      onTouchStart={onTouchStart}
    >
      {Icon && renderIcon()}
      <Typography
        fontSize={fontSize}
        sx={{
          textAlign: 'center',
          mt: 0.6,
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          userSelect: 'none',
          WebkitUserSelect: 'none',
          MozUserSelect: 'none',
          msUserSelect: 'none',
          pointerEvents: 'none', // Evita que el texto capture eventos de mouse/touch
        }}
      >
        {description.length > 15 && flexDirection !== 'row'
          ? `${description.substring(0, 15)}...`
          : description}
      </Typography>
    </Button>
  );
};

export default ButtonTienda